import { LoadbarComponent } from "appworks/components/preloader/loadbar-component";
import { FileLocation } from "appworks/config/asset-config-schema";
import { SmartShape } from "appworks/graphics/elements/smart-shape";
import { Layers } from "appworks/graphics/layers/layers";
import { Sprite } from "appworks/graphics/pixi/sprite";
import { Text } from "appworks/graphics/pixi/text";
import { loader } from "appworks/loader/loader";
import { Services } from "appworks/services/services";
import { SoundEvent } from "appworks/services/sound/sound-events";
import { Contract } from "appworks/utils/contracts/contract";
import { Sequence } from "appworks/utils/contracts/sequence";
import { LoaderResource } from "pixi.js";
import { Signal } from "signals";
import { AbstractComponent } from "../abstract-component";

export class PreloaderComponent extends AbstractComponent {

    public onProgress: Signal = new Signal();
    public onComplete: Signal = new Signal();

    protected loadBar: LoadbarComponent;

    private progressText: Text;

    public start(files: FileLocation[]) {
        if (Layers.get("Background")?.hasScene("preloader")) {
            Layers.get("Background").setScene("preloader").execute();
        }

        const menusLayer = Layers.get("Menus");

        let bar: Sprite;
        let barMask: Sprite | SmartShape;
        let chaser: Sprite;

        if (menusLayer?.hasScene("preloader")) {
            menusLayer.setScene("preloader").execute();
            menusLayer.show();

            bar = menusLayer.getSprite("loader_bar");
            chaser = menusLayer.getSprite("loader_bar_chaser");
            this.progressText = menusLayer.getText("loader_text");

            barMask =
                menusLayer.getSprite("loader_bar_mask") ||
                menusLayer.getShape("loader_bar_mask");
            if (barMask) {
                bar.mask = barMask;
            }
        }

        this.loadBar = new LoadbarComponent(files, barMask || bar, chaser);

        this.loadBar.onChange.add(() => this.update());

        if (Services.jurisdiction.getMinPreloaderTime() > 0) {
            loader.minPreloaderTime = Services.jurisdiction.getMinPreloaderTime();
        }
    }

    public fileLoaded(resource: LoaderResource) {
        if (this.loadBar) {
            this.loadBar.fileLoaded(resource);
        }
    }

    /**
     * Quickly completes the loadbar and returns a Contract for when it's done
     */
    public loadComplete() {
        Services.sound.event(SoundEvent.preload_complete);

        if (this.loadBar) {
            return new Sequence([
                () => this.loadBar.loadComplete(),
                () => Contract.wrap(() => {
                    this.onComplete.dispatch();
                    this.destroy();
                })
            ]);
        } else {
            this.destroy();
            return Contract.empty();
        }
    }

    public destroy() {
        this.progressText = null;

        Layers.get("Background")?.defaultScene().execute();
        Layers.get("Menus")?.clear();
    }

    protected update() {
        if (this.progressText) {
            this.progressText.text = Services.translations.get("prl.loa", { PROGRESS: Math.round(this.loadBar.currentPercent * 100) });
        }

        this.onProgress.dispatch(this.loadBar.currentPercent);
    }
}
